import { getPriceAndDiscount } from '@/app/[locale]/product/_components/HardwarePDP/_utils/getPriceAndDiscount';
import MembershipSelection from '@/app/[locale]/product/_steps/enums/MembershipSelection';
import WarrantySelection from '@/app/[locale]/product/_steps/enums/WarrantySelection';

import type { UseOR4PDPPageReturn } from '../_hooks/useOR4PDPPage';

interface GetTotalPriceReturn {
  totalDiscount: number;
  totalPrice: number;
}

const getTotalPrice = ({
  order,
  product,
  threeYearWarranty,
  twoYearWarranty,
  yearlyMembership,
}: Partial<UseOR4PDPPageReturn>): GetTotalPriceReturn => {
  const membership = order?.membership.value as MembershipSelection;
  const warranty = order?.warranty.value as WarrantySelection;

  const { discountPrice: productDiscount, price: productPrice } =
    getPriceAndDiscount(product);
  const {
    discountPrice: membershipYearlyDiscount,
    price: membershipYearlyPrice,
  } = getPriceAndDiscount(yearlyMembership);
  const { price: warrantyTwoYearPrice } = getPriceAndDiscount(twoYearWarranty);
  const { price: warrantyThreeYearPrice } =
    getPriceAndDiscount(threeYearWarranty);

  let membershipPrice = 0;
  if (membershipYearlyPrice && membership === MembershipSelection.OneYear) {
    membershipPrice = membershipYearlyPrice;
  }

  let warrantyPrice = 0;
  if (warrantyTwoYearPrice && warrantyThreeYearPrice) {
    if (warranty === WarrantySelection.TwoYear) {
      warrantyPrice = warrantyTwoYearPrice;
    } else if (warranty === WarrantySelection.ThreeYear) {
      warrantyPrice = warrantyThreeYearPrice;
    }
  }

  const totalDiscount = productDiscount + membershipYearlyDiscount;
  const totalPrice = [productPrice, membershipPrice, warrantyPrice].reduce(
    (acc: number, price) => acc + (price ?? 0),
    0,
  );

  return { totalDiscount, totalPrice };
};

export default getTotalPrice;
